import Image from "next/image";

import { Carousel } from "react-responsive-carousel";

import Heading from "./Heading";

const BusinessConsumption = () => (
  <>
    <Heading
      title="Tailored for Business Consumption"
      subtitle="Wide variety of interactive visualizations and simulations "
    />
    <Carousel showThumbs={false} showStatus={false} autoPlay infiniteLoop>
      <div className="bg-white h-full">
        <p className="pb-4 text-base font-bold">
          Relationships Strucures in your data
        </p>
        <Image
          src="/relationships.png"
          width={400}
          height={200}
          layout="responsive"
          className="md:max-w-2xl mx-auto rounded object-contain pt-4"
          alt="Relationships"
        />
      </div>
      <div className="bg-white h-full">
        <p className="pb-4 text-base font-bold">
          Clusters where an experiment has had the most impact
        </p>
        <Image
          src="/uplift-clusters.png"
          width={400}
          height={200}
          layout="responsive"
          alt="Clusters"
          className="md:max-w-2xl mx-auto rounded object-contain pt-4"
        />
      </div>
      <div className="bg-white h-full">
        <p className="pb-4 text-base font-bold">
          Anomaly Detection along with Expected Ranges
        </p>
        <Image
          src="/time-series-anomalies.png"
          width={400}
          height={200}
          layout="responsive"
          alt="Time Series Anomalies"
          className="md:max-w-2xl mx-auto rounded object-contain pt-4"
        />
      </div>
      <div className="bg-white h-full">
        <p className="pb-4 text-base font-bold">Scenarios and Simulations</p>
        <Image
          src="/scenarios.png"
          width={400}
          height={200}
          layout="responsive"
          alt="Scenarios and Simulations"
          className="md:max-w-2xl mx-auto rounded object-contain pt-4"
        />
      </div>
      <div className="bg-white h-full">
        <p className="pb-4 text-base font-bold">And many many more...</p>
        <Image
          src="/cluster-profiles.png"
          width={400}
          height={200}
          layout="responsive"
          alt="Profiles"
          className="md:max-w-2xl mx-auto rounded object-contain pt-4"
        />
      </div>
    </Carousel>
  </>
);

export default BusinessConsumption;
